var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabourMarketData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.842,
    height: 35.99,
    viewBox: "0 0 37.842 35.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "optimization",
    d: "M46.959,38.156a15.285,15.285,0,0,1,1.051,3L50.99,42.3v4.869l-2.981,1.147a15.445,15.445,0,0,1-1.863,4.5L47.44,55.74,44,59.182l-2.922-1.295a15.257,15.257,0,0,1-4.5,1.863l-1.147,2.981H30.563l-1.147-2.981a15.417,15.417,0,0,1-4.5-1.863l-2.922,1.295L18.55,55.74l1.3-2.922a15.4,15.4,0,0,1-1.868-4.5L15,47.174V42.3l2.981-1.147a15.428,15.428,0,0,1,1.868-4.5l-1.3-2.922,3.442-3.442,2.922,1.3a15.312,15.312,0,0,1,4.5-1.863l1.152-2.986h4.869l1.147,2.986a15.312,15.312,0,0,1,4.5,1.863L44,30.292l.82.82-5.39,6.053a9.9,9.9,0,1,0,3.329,5.709Zm3.31-5.616q-.027.033-.056.066L39.921,44.161a1.88,1.88,0,0,1-2.525.259l-2.846-2.113-4.34,4.34a1.88,1.88,0,0,1-2.659-2.659L33.04,38.5a1.88,1.88,0,0,1,2.45-.18l2.767,2.055L47.4,30.105l.039-.042-1.362-1.194a.389.389,0,0,1,.167-.671l6.115-1.445a.389.389,0,0,1,.476.418l-.634,6.252a.389.389,0,0,1-.643.253Z",
    transform: "translate(-15 -26.742)",
    fill: "#3db6fb",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabourMarketData);
export default __webpack_public_path__ + "static/media/Labour-market Data.2d273359e830ff0a15b8234824ca56e2.svg";
export { ForwardRef as ReactComponent };